import './StatusClosedForm.scss'

import React, {Component} from 'react'
import {createStructuredSelector} from 'reselect'
import {StatusSubmitButton} from 'manager/views/components/ReferralStatus/StatusSubmitButton'
import {connect} from 'react-redux'
import FeedbackTextbox from 'common/views/components/FeedbackTextbox'
import {
  markFieldBlurred,
  saveClosedPage1,
  saveClosedPage2,
  saveStatus,
  setField,
  usePriorSettlementSelection
} from 'manager/redux/referral_status'
import {show as showModal} from 'redux-modal'
import {DatePicker} from 'manager/views/components/ReferralStatus/SingleDatePicker'
import {FinancingCategoryDropdown} from 'manager/views/components/ReferralStatus/FinancingCategoryDropdown'
import {fromCurrency, scrollToTop, toCurrency} from 'manager/util/helper'
import AddressAutocomplete from 'common/views/atoms/AddressAutocomplete/AddressAutocomplete'
import {NoteField} from 'manager/views/components/ReferralStatus/NoteField'
import {
  selectCloseAmount,
  selectCloseDate,
  selectCloseDateErrorMsg,
  selectClosedPage1FormIsValid,
  selectCloseMLS,
  selectClosePropertyAddress,
  selectCommissionAmount,
  selectValidationAttempted
} from 'manager/selectors/referral_status_selectors'
import {
  selectIsLease,
  selectReferralQualiaEnabled,
  selectSelectedSettlementProvider
} from 'manager/selectors/referral_selectors'


class ClosedFormPage1 extends Component {

  onSubmit = async () => {
    const {
      saveClosedPage1,
      close_mls,
      close_property_address,
      close_amount,
      commission_amount,
      close_date,
      isLease,
      isReferralQualiaEnabled,
      previouslySelectedSettlementProvider,
      usePriorSettlementSelection,
    } = this.props
    const currentPage = isLease ? 1 : 2
    if (isReferralQualiaEnabled && previouslySelectedSettlementProvider) {
      usePriorSettlementSelection()
    }
    saveClosedPage1({
      close_mls,
      close_property_address,
      close_amount,
      commission_amount,
      close_date,
      currentPage
    })
    if(isLease){
      await this.onSubmitLease()
    }
  }

  onSubmitLease = async () => {
    const error = await this.props.saveClosedPage2({})
    if (!error) {
      this.props.showModal('CongratsClosedModal')
    }
  }

  render() {
    const {
      isValid,
      isLease,
      close_mls,
      close_property_address,
      close_amount,
      commission_amount,
      close_date,
      setField,
      closeDateErrorMsg,
      markFieldBlurred
    } = this.props

    return (
      <div className="StatusClosedForm">
        <div className="ReferralStatusForm__body">
          <div className="StatusClosedForm__blue_header">
            <span className="StatusClosedForm__congrats">Congratulations!</span>
            <p className="StatusClosedForm__text">
              Nice work on closing this transaction!<br/>
              We just need to collect a few final details.
            </p>
          </div>
          <div className="StatusClosedForm__blurb">
            <p className="StatusClosedForm__text">
              As a final step, please confirm and/or provide the<br/>
              following transaction information.
            </p>
          </div>
          <div className="StatusClosedForm__notefield">
            <NoteField />
          </div>
          {!isLease && <div className="StatusClosedForm__subtitle">CONTRACT DETAILS <span className="StatusClosedForm__subsubtitle">1 of 2</span></div>}
          <div className="StatusClosedForm__property_inputs">
            <fieldset className="AddressAutocomplete form-group">
              <label>Property Address</label>
              <AddressAutocomplete
                inputProps={{
                  value: close_property_address,
                  onChange: value => setField('close_property_address', value),
                  placeholder: "123 Main Street, Austin, TX 78701",
                  onFocus: scrollToTop
                }}
                styles={{    
                  input: {fontFamily: 'Circular'} 
                }}
              />
            </fieldset>
            <FeedbackTextbox
              label="MLS Number"
              value={close_mls}
              placeholder="123456"
              onChange={evt => setField('close_mls', evt.target.value)}
              errorMsg={null}
              onFocus={scrollToTop}
              manualClassName="FeedbackTextbox__circular"
            />
            <FeedbackTextbox
              label="Final Close Amount"
              value={toCurrency(close_amount)}
              type="text"
              pattern={"$([0-9]+,)*"}
              placeholder="$150,000"
              onChange={evt => setField('close_amount', fromCurrency(evt.target.value))}
              errorMsg={null}
              onFocus={scrollToTop}
              manualClassName="FeedbackTextbox__circular"
            />
            <FeedbackTextbox
              label="Final Agent Commission Amount"
              value={toCurrency(commission_amount)}
              type="text"
              pattern={"$([0-9]+,)*"}
              placeholder="$40,000"
              onChange={evt => setField('commission_amount', fromCurrency(evt.target.value))}
              errorMsg={null}
              onFocus={scrollToTop}
              manualClassName="FeedbackTextbox__circular"
            />
            <DatePicker
              label={isLease ? "Expected Commission Date" : "Actual Close Date"}
              useNative
              value={close_date}
              onChange={date => setField('close_date', date)}
              errorMsg={closeDateErrorMsg}
              pastDatesOnly
              orientation="vertical"
              onBlur={() => markFieldBlurred('close_date')}
              manualClassName="circularFont"
            />
            {!isLease && <FinancingCategoryDropdown />}
          </div>
        </div>
        <div className="ReferralStatusForm__footer">
          <StatusSubmitButton
            disabled={!isValid}
            onClick={this.onSubmit}>
            {isLease ? "Complete" : "Save & continue"}
          </StatusSubmitButton>
        </div>
      </div>
    )
  }
}


const selector = createStructuredSelector({
  isValid: selectClosedPage1FormIsValid,
  validationAttempted: selectValidationAttempted,
  isLease: selectIsLease,
  close_mls: selectCloseMLS,
  close_property_address: selectClosePropertyAddress,
  close_amount: selectCloseAmount,
  close_date: selectCloseDate,
  commission_amount: selectCommissionAmount,
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
  previouslySelectedSettlementProvider: selectSelectedSettlementProvider,
  closeDateErrorMsg: selectCloseDateErrorMsg,
})

const actions = {
  saveStatus,
  setField,
  usePriorSettlementSelection,
  saveClosedPage1,
  saveClosedPage2,
  showModal,
  markFieldBlurred,
}

export const StatusClosedPage1 = connect(selector, actions)(ClosedFormPage1)
